import React from "react";
import { useForm } from "react-hook-form";
import PropTypes from "prop-types";

const ProjectForm = ({ setData, data, handleSubmitProp }) => {
    const { register, handleSubmit, errors } = useForm({
        mode: "onBlur",
    });
    const onSubmit = (data) => console.log(data);

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="row gx-10">
                <div className="col-md-4">
                    <div className="single-form">
                        <input
                            type="text"
                            name="title"
                            placeholder="Enter your title..."
                            ref={register({ required: "Title is required" })}
                            onChange={(e) => {
                                setData({ ...data, title: e.target.value });
                            }}
                            value={data.title}
                        />
                        {errors.title && <p>{errors.title.message}</p>}
                    </div>
                </div>
                {/* <div className="col-md-4">
                    <div className="single-form">
                        <input
                            type="text"
                            name="title"
                            placeholder="title"
                            ref={register({
                                required: "title",
                            })}
                        />
                        {errors.email && <p>{errors.email.message}</p>}
                    </div>
                </div> */}
                <div className="col-md-4">
                    <div className="single-form">
                        <input
                            type="file"
                            name="image"
                            placeholder="Subject"
                            ref={register({ required: "File is required" })}
                            onChange={(e) => {
                                if (!e.target.files) {
                                    return;
                                }
                                const objectUrl = URL.createObjectURL(
                                    e.target.files[0]
                                );
                                console.log(e.target.files[0]);
                                setData({
                                    ...data,
                                    media: { ...data.media, thumb: objectUrl },
                                    img: e.target.files[0],
                                });
                            }}
                        />
                        {errors.image && <p>{errors.image.message}</p>}
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="single-form">
                        <textarea
                            name="description"
                            placeholder="Here goes your description"
                            ref={register({
                                required: "Description is required",
                            })}
                            onChange={(e) => {
                                setData({
                                    ...data,
                                    description: e.target.value,
                                });
                            }}
                            value={data.description}
                        ></textarea>
                        {errors.description && (
                            <p>{errors.description.message}</p>
                        )}
                    </div>
                </div>
            </div>
            <div className="col-md-12">
                <div className="form-btn">
                    <button onClick={handleSubmitProp}>Submit</button>
                </div>
            </div>
        </form>
    );
};

ProjectForm.propTypes = {
    setData: PropTypes.any,
    data: PropTypes.any,
    handleSubmitProp: PropTypes.any,
};

export default ProjectForm;
